<glxy-empty-state>
  <glxy-empty-state-hero>
    <img [src]="emptyStateImageUrl" />
  </glxy-empty-state-hero>
  <glxy-empty-state-title>
    {{ 'PAYMENTS_ONBOARDING.UNSUPPORTED_REGION.TITLE' | translate }}
  </glxy-empty-state-title>
  <p>
    {{ 'PAYMENTS_ONBOARDING.UNSUPPORTED_REGION.DESCRIPTION' | translate }}
  </p>
  <glxy-empty-state-actions>
    <a mat-flat-button color="primary" (click)="onAction()" data-testid="clicked-vendasta-payments-contact-us">
      {{ 'PAYMENTS_ONBOARDING.UNSUPPORTED_REGION.CONTACT_US' | translate }}
    </a>
  </glxy-empty-state-actions>
</glxy-empty-state>
